import React from 'react';
import PropTypes from 'prop-types';
import { TextField, Text } from '@fluentui/react';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getTextFieldWithSuffixStyles, unitStyles } from './styles/get-text-field-with-suffix-styles';

export const TextFieldWithSuffix = (props) => {
  const { unit } = props;
  const classes = useDefaultStyles(getTextFieldWithSuffixStyles);

  return (
    <div className={classes.textFieldWithSuffix}>
      <TextField {...props} />
      <Text styles={unitStyles}>{unit}</Text>
    </div>
  );
};

TextFieldWithSuffix.propTypes = {
  unit: PropTypes.string.isRequired,
};

